module.exports = __webpack_public_path__ + "img/icon_touxiang_106@2x.6a654627.png";